import React, {memo, useCallback, useEffect, useState, useMemo} from "react";
import {isEmpty} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {useMediaQuery} from "react-responsive";
import ProtectedContent from "../../../components/protectedContent";
import SummaryTable from "./summaryTable";
import ProbesModal from "../../../components/Modal/ProbesModal";
import EmptySummary from "./EmptySummary";
import SummaryHeader from "./summaryHeader";
import Accordion from "../../../components/Accordion/accordion";
import {
  requestCreateProbe,
  requestSummaryData,
} from "../../../redux/Actions/controllers.actions";
import {getFormattedSummaryData} from "../../../redux/Selectors/controllers.selectors";
import "./summary.scss";

const Summary = ({ioTypes}) => {
  const dispatch = useDispatch();
  const summaryDetails = useSelector(getFormattedSummaryData);
  const isMobileOrTablet = useMediaQuery({query: "(max-width: 1080px)"});
  const [modalDetails, toggleIOModal] = useState({
    isModalOpen: false,
    ioType: "",
  });
  const summaryDetailsKeys = useMemo(() => Object.keys(summaryDetails), [summaryDetails]);
  const [openIndices, setOpenIndices] = useState({});

  const modalHandler = useCallback(
    (ioType) => {
      toggleIOModal({isModalOpen: true, ioType});
    },
    [toggleIOModal]
  );

  const closeModalHandler = useCallback(() => {
    toggleIOModal({isModalOpen: false, ioType: ""});
  }, [toggleIOModal]);

  const probesSubmitHandler = (finaldata) => {
    dispatch(requestCreateProbe(finaldata, closeModalHandler));
  };

  useEffect(() => {
    dispatch(requestSummaryData(true));
    const interval = setInterval(() => {
      dispatch(requestSummaryData());
    }, 30000);
    return () => clearInterval(interval);
  }, [dispatch]);

  const toggleAccordion = (key) => {
    setOpenIndices((prevOpenIndices) => ({
      ...prevOpenIndices,
      [key]: !prevOpenIndices[key],
    }));
  };

  return (
    <>
      {modalDetails.isModalOpen && (
        <ProbesModal
          ioType={modalDetails.ioType}
          open={modalDetails.isModalOpen}
          onSend={probesSubmitHandler}
          onCancel={closeModalHandler}
        />
      )}
      {isEmpty(summaryDetails) ? (
        <ProtectedContent perms={["add_inventorysensors"]}>
          <EmptySummary ioTypes={ioTypes} modalHandler={modalHandler} />
        </ProtectedContent>
      ) : (
        <div
          style={{
            position: "relative",
            paddingTop: isMobileOrTablet ? "0px" : "20px",
            height: "100vh",
          }}
        >
          <SummaryHeader ioTypes={ioTypes} modalHandler={modalHandler} />
          <div style={{paddingTop: isMobileOrTablet ? "0px" : "40px"}}>
            {summaryDetailsKeys.map((key) => (
              <Accordion
                key={key}
                title={key}
                content={<SummaryTable summaryDetails={summaryDetails[key]} />}
                isOpen={Boolean(openIndices[key])}
                onToggle={() => toggleAccordion(key)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default memo(Summary);
